import { useEffect } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useSelector } from "react-redux";
import Loader from "../../components/loader";
import { coachPaths } from "../../routes/coach";
import { useNavigate } from "react-router-dom";
const SalesServiceSubscription = () => {
  const { isLoading2 } = useSelector((state) => state.coach.coach);
  const { isLoading } = useSelector((state) => state.coach.auth);
  const navigate = useNavigate();
  const user = { name: "find-a-coach", role: "coach" };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      <section class="ct_workshop_banner ct_px_40 py-4">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-7 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-duration="3000"
            >
              <h2
                class="ct_fs_50_new mb-4 ct_darkblue_text"
                style={{ maxWidth: "615px" }}
              >
                Find the <span className="ct_yellow_text">Perfect</span> Package
                for Your Business
              </h2>
              <p
                class="mb-0 ct_fs_20 ct_darkblue_text"
                style={{ maxWidth: "639px" }}
              >
                Whether you need sales acceleration, stunning digital design, or
                seamless customer support, our flexible packages are crafted to
                meet your unique goals and drive real impact.
              </p>
              <div class="ct_mt_40">
                <a class="ct_yellow_btn px-5 ct_fit_content">Let’s Talk</a>
              </div>
            </div>
            <div
              class="col-lg-5 mb-4 mb-lg-0"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <div class="ct_workshop_right_img">
                <img
                  src="../assets/img/pexels-blue-bird-7243007_67.png"
                  style={{ maxWidth: "100%" }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_py_130 pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <h4 className="ct_fs_32 ct_darkblue_text mb-4">
                  Find the Right Plan for Your Needs — Fast
                </h4>
                <p
                  className="mb-0 ct_fs_20 ct_darkblue_text mx-auto"
                  style={{ maxWidth: "1121px" }}
                >
                  Browse a range of service subscriptions across design,
                  marketing, sales, and more. Easily search and select the
                  perfect fit to grow your business seamlessly.
                </p>

                <div className="ct_mt_60">
                  <ul className="ct_job_categories_tags ct_subs__categories_tags">
                    <li className="ct_h_40 active">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Sales
                    </li>
                    <li className="ct_h_40">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Marketing
                    </li>
                    <li className="ct_h_40">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Customer Service
                    </li>
                    <li className="ct_h_40">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Web Design
                    </li>
                    <li className="ct_h_40">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Mobile Design
                    </li>
                    <li className="ct_h_40">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Software Development
                    </li>
                    <li className="ct_h_40">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66536 3.33398H9.33203V12.6673H6.66536V3.33398ZM3.33203 12.6673V6.66732H5.9987V12.6673H3.33203ZM4.66536 3.33398C4.31174 3.33398 3.9726 3.47446 3.72256 3.72451C3.47251 3.97456 3.33203 4.3137 3.33203 4.66732C3.33203 5.02094 3.47251 5.36008 3.72256 5.61013C3.9726 5.86017 4.31174 6.00065 4.66536 6.00065C5.01899 6.00065 5.35812 5.86017 5.60817 5.61013C5.85822 5.36008 5.9987 5.02094 5.9987 4.66732C5.9987 4.3137 5.85822 3.97456 5.60817 3.72451C5.35812 3.47446 5.01899 3.33398 4.66536 3.33398ZM9.9987 3.33398H12.6654V6.00065H9.9987V3.33398ZM12.6654 6.66732H9.9987V9.33398H12.6654V6.66732Z"
                          fill="#023047"
                        />
                      </svg>
                      Product Management
                    </li>
                  </ul>

                  <div className="row ct_mt_30">
                    <div className="col-md-8 mx-auto">
                      <div class="d-flex align-items-center gap-3 justify-content-center">
                        <div className="form-group w-100 text-start">
                          <label className="mb-2 ct_fs_14 ct_darkblue_text">
                            Types of Service
                          </label>
                          <select className="form-control ct_input">
                            <option>Sales Only</option>
                          </select>
                        </div>
                        <div className="form-group w-100 text-start">
                          <label className="mb-2 ct_fs_14 ct_darkblue_text">
                            Length of Subscription
                          </label>
                          <select className="form-control ct_input">
                            <option>12-Months</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div>
          <section className="ct_px_40  ct_mt_100">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 ct_darkblue_text mb-4">
                    Sales Packages Designed for Growth
                  </h4>
                  <p
                    className="mb-0 ct_fs_16 ct_darkblue_text"
                    style={{ maxWidth: "531px" }}
                  >
                    From lean startups to scaling teams, choose a package that
                    fits your sales goals with the tools, support, and strategy
                    to help you close with confidence.
                  </p>
                </div>
              </div>
              <div class="row ct_mt_60 ">
                <div class="col-lg-4  mb-5  ">
                  <div
                    class="ct_pricing_card  ct_mt_30 "
                    style={{ borderColor: "#8ECAE6", paddingBottom: "76px" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Starter Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $30 <span className="ct_fs_18">/6 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Perfect for short-term goals
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Access to all core sales features
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Basic performance reporting
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Email support
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Flexible for pilot projects
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-5 ">
                  <div
                    class="ct_pricing_card"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                          <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                            Pro Plan
                          </p>
                          <span
                            class="ct_most_popular_badge ct_flex_shrink_0"
                            style={{
                              backgroundColor: "var(--dark_blue) ",
                              color: "#fff",
                            }}
                          >
                            Most Popular
                          </span>
                        </div>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $100 <span className="ct_fs_18">/12 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Ideal for growing teams ready to scale
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 6-month plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Advanced CRM integration
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Quarterly strategy check-ins
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Priority support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4  mb-5 ">
                  <div
                    class="ct_pricing_card  ct_mt_30"
                    style={{ borderColor: "#8ECAE6", paddingBottom: "76px" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Enterprise Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $150<span className="ct_fs_18">/36 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          For teams committed to long-term sales
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 1-year plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Dedicated success manager
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Annual performance reviews
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Custom optimization support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            class="ct_looking_for_work_bg  ct_mt_60     ct_p_111_y_106"
            style={{ backgroundColor: "var(--orange)" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4
                  class="ct_fs_36 mb-4 text-white"
                  style={{ maxWidth: "600px" }}
                >
                  Didn’t Find What You’re Looking For?
                </h4>
                <p class="mb-0 ct_fs_18" style={{ maxWidth: "658px" }}>
                  We’re here to help. Let us know your unique needs and we’ll
                  create a custom solution that fits just right.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(coachPaths?.ContactUs, {
                      state: { data: "landing" },
                    });
                  }}
                >
                  Talk to Us
                </a>
              </div>
            </div>
          </section>
          <section className="ct_mt_100 ct_px_40">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-6 mb-4">
                  <div>
                    <h4
                      className="ct_fs_24_new ct_darkblue_text mb-4"
                      style={{ maxWidth: "559px" }}
                    >
                      Sales & Marketing Packages Built to Accelerate Growth
                    </h4>
                    <p
                      className="mb-0 ct_mt_40 ct_darkblue_text"
                      style={{ maxWidth: "575px" }}
                    >
                      Whether you're a growing brand or an established business,
                      our packages are tailored to help you attract the right
                      audience, convert leads efficiently, and scale your
                      revenue with confidence and clarity.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="ct_sales_marketing_img_890">
                    <img
                      src="../assets/img/sales_marketing_right_img.png"
                      className="ct_img_h_460 ct_border_radius_70"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_mt_200 ct_subscription_btm_tiangle_shape">
            <div className="container">
              <div class="row align-items-end ">
                <div class="col-lg-4  mb-5  ">
                  <div
                    class="ct_pricing_card h-auto d-block bg-white  "
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Starter Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $30 <span className="ct_fs_18">/6 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Perfect for short-term goals
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Access to all core sales features
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Basic performance reporting
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Email support
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Flexible for pilot projects
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto pt-5">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-5 ">
                  <div
                    class="ct_pricing_card  h-auto d-block bg-white"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                          <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                            Pro Plan
                          </p>
                          <span
                            class="ct_most_popular_badge ct_flex_shrink_0"
                            style={{
                              backgroundColor: "var(--yellow) ",
                              color: "var(--dark_blue)",
                            }}
                          >
                            Most Popular
                          </span>
                        </div>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $100 <span className="ct_fs_18">/12 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Ideal for growing teams ready to scale
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 6-month plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Advanced CRM integration
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Quarterly strategy check-ins
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Priority support
                        </li>
                      </ul>
                      <p
                        className="ct_fs_18 ct_darkblue_text ct_text_op_8"
                        style={{ maxWidth: "273px" }}
                      >
                        Everything in 6-month plan Advanced CRM integration
                        Quarterly strategy check-ins Priority support
                      </p>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4  mb-5 ">
                  <div
                    class="ct_pricing_card  h-auto d-block bg-white "
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Enterprise Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $150<span className="ct_fs_18">/36 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          For teams committed to long-term sales
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 1-year plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Dedicated success manager
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Annual performance reviews
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Custom optimization support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto pt-5">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_px_40  ct_mt_100">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 ct_darkblue_text mb-4">
                    Sales & Customer Service Packages Designed for Impact
                  </h4>
                  <p
                    className="mb-0 ct_fs_16 ct_darkblue_text"
                    style={{ maxWidth: "900px" }}
                  >
                    From first contact to lasting relationships, our packages
                    equip your team with the right tools, support, and strategy
                    to close deals faster and deliver standout service that
                    keeps customers coming back.
                  </p>
                </div>
              </div>
              <div class="row ct_mt_60 ">
                <div class="col-lg-4  mb-5  ">
                  <div
                    class="ct_pricing_card  ct_mt_30 "
                    style={{ borderColor: "#8ECAE6", paddingBottom: "76px" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Starter Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $30 <span className="ct_fs_18">/6 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Perfect for short-term goals
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Access to all core sales features
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Basic performance reporting
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Email support
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Flexible for pilot projects
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-5 ">
                  <div
                    class="ct_pricing_card"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                          <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                            Pro Plan
                          </p>
                          <span
                            class="ct_most_popular_badge ct_flex_shrink_0"
                            style={{
                              backgroundColor: "var(--dark_blue) ",
                              color: "#fff",
                            }}
                          >
                            Most Popular
                          </span>
                        </div>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $100 <span className="ct_fs_18">/12 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Ideal for growing teams ready to scale
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 6-month plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Advanced CRM integration
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Quarterly strategy check-ins
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Priority support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4  mb-5 ">
                  <div
                    class="ct_pricing_card  ct_mt_30"
                    style={{ borderColor: "#8ECAE6", paddingBottom: "76px" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Enterprise Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $150<span className="ct_fs_18">/36 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          For teams committed to long-term sales
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 1-year plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Dedicated success manager
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Annual performance reviews
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Custom optimization support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left ct_mt_60     ct_p_111_y_106"
            style={{ backgroundColor: "var(--yellow)" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4
                  class="ct_fs_36 mb-4 text-white"
                  style={{ maxWidth: "600px" }}
                >
                  Need Something More Tailored?
                </h4>
                <p class="mb-0 ct_fs_18" style={{ maxWidth: "733px" }}>
                  We’ve got you covered. Share your specific goals and we’ll
                  craft a custom plan built around your business needs.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(coachPaths?.ContactUs, {
                      state: { data: "landing" },
                    });
                  }}
                >
                  Talk to Us
                </a>
              </div>
            </div>
          </section>
          <section className="ct_px_40  ct_mt_100">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 ct_darkblue_text mb-4">
                    Sales, Marketing & Customer Service Packages Designed for
                    Real Results
                  </h4>
                  <p
                    className="mb-0 ct_fs_16 ct_darkblue_text"
                    style={{ maxWidth: "1105px" }}
                  >
                    From lead generation to loyal retention, our all-in-one
                    packages give your team the strategy, tools, and support to
                    attract the right audience, close deals faster, and deliver
                    exceptional customer experiences — all in one seamless
                    solution.
                  </p>
                </div>
              </div>
              <div class="row ct_mt_60 ">
                <div class="col-lg-4  mb-5  ">
                  <div
                    class="ct_pricing_card  ct_mt_30 "
                    style={{ borderColor: "#8ECAE6", paddingBottom: "76px" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Starter Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $30 <span className="ct_fs_18">/6 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Perfect for short-term goals
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Access to all core sales features
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Basic performance reporting
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Email support
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Flexible for pilot projects
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-5 ">
                  <div
                    class="ct_pricing_card"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                          <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                            Pro Plan
                          </p>
                          <span
                            class="ct_most_popular_badge ct_flex_shrink_0"
                            style={{
                              backgroundColor: "var(--dark_blue) ",
                              color: "#fff",
                            }}
                          >
                            Most Popular
                          </span>
                        </div>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $100 <span className="ct_fs_18">/12 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          Ideal for growing teams ready to scale
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 6-month plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Advanced CRM integration
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Quarterly strategy check-ins
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Priority support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4  mb-5 ">
                  <div
                    class="ct_pricing_card  ct_mt_30"
                    style={{ borderColor: "#8ECAE6", paddingBottom: "76px" }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Enterprise Plan
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $150<span className="ct_fs_18">/36 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text">
                          For teams committed to long-term sales
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Everything in 1-year plan
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Dedicated success manager
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Annual performance reviews
                        </li>
                        <li className="ct_fs_18">
                          <i
                            class="fa-solid fa-check"
                            style={{ backgroundColor: "#023047" }}
                          ></i>{" "}
                          Custom optimization support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="ct_looking_for_work_bg  ct_mt_60     ct_p_111_y_106"
            style={{ backgroundColor: "var(--orange)" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4
                  class="ct_fs_36 mb-4 text-white"
                  style={{ maxWidth: "600px" }}
                >
                  All-in-One Solutions for Growing Teams
                </h4>
                <p class="mb-0 ct_fs_18" style={{ maxWidth: "658px" }}>
                  From sales and marketing to design and support simplify your
                  operations with bundled packages tailored to scale your
                  business smarter and faster.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
                  Combined Services
                </a>
              </div>
            </div>
          </section>

          <section
            className="ct_px_40  ct_mt_100 "
            style={{
              backgroundColor: "hsl(199deg 64% 73% / 10%)",
              padding: "43px 0px 189px",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center">
                  <h4 className="ct_fs_32 ct_darkblue_text mb-4">
                    Complete Growth Solutions for Modern Teams
                  </h4>
                  <p
                    className="mb-0 ct_fs_16 ct_darkblue_text mx-auto"
                    style={{ maxWidth: "1053px" }}
                  >
                    From first impression to final conversion and beyond, our
                    all-in-one packages bring together powerful sales
                    strategies, smart marketing, stunning web design, and
                    seamless customer service everything you need to attract,
                    convert, and retain with ease.
                  </p>
                </div>
              </div>
              <div class="row ct_mt_60 ">
                <div class="col-lg-4  mb-5  ">
                  <div
                    class="ct_pricing_card text-white  ct_mt_30 "
                    style={{
                      borderColor: "hsl(200deg 95% 14% / 50%)",
                      paddingBottom: "76px",
                      backgroundColor: "hsl(200deg 95% 14% / 60%)",
                    }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 text-white">
                          Starter Growth
                        </p>
                        <h2 class="ct_fs_44  mb-0 text-white ">
                          $30 <span className="ct_fs_18">/6 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 text-white ct_text_op_8">
                          Ideal for startups or small businesses launching or
                          scaling
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                              fill="white"
                            />
                            <path
                              d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                              fill="#023047"
                            />
                          </svg>
                          Basic website or landing page setup
                        </li>

                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                              fill="white"
                            />
                            <path
                              d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                              fill="#023047"
                            />
                          </svg>
                          Social media management + content creation
                        </li>
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                              fill="white"
                            />
                            <path
                              d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                              fill="#023047"
                            />
                          </svg>
                          Customer support setup (email/chat/FAQ)
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Choose Plan
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-5 ">
                  <div
                    class="ct_pricing_card"
                    style={{
                      borderColor: "hsl(200deg 95% 14% / 50%)",
                      backgroundColor: "hsl(32deg 100% 49% / 60%)",
                    }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-0">
                          <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                            Revenue Accelerator
                          </p>
                          <span
                            class="ct_most_popular_badge ct_flex_shrink_0"
                            style={{
                              backgroundColor: "var(--dark_blue) ",
                              color: "#fff",
                            }}
                          >
                            Most Popular
                          </span>
                        </div>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $100 <span className="ct_fs_18">/12 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_darkblue_text ct_text_op_8">
                          Perfect for SMEs ready to boost sales and visibility
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          CRM setup & optimized sales funnels
                        </li>
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Outbound lead gen + email campaigns
                        </li>
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Dedicated customer support agent(s)
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Choose Plan
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4  mb-5 ">
                  <div
                    class="ct_pricing_card  ct_mt_30"
                    style={{
                      borderColor: "hsl(200deg 95% 14% / 50%)",
                      backgroundColor: "hsl(43deg 100% 51% / 60%)",
                      paddingBottom: "76px",
                    }}
                  >
                    <div>
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="ct_mb_16 ct_fs_20 ct_darkblue_text">
                          Full Service Operation
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_darkblue_text ">
                          $150<span className="ct_fs_18">/36 Months </span>
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_18 ct_text_op_8 ct_darkblue_text">
                          For growing companies needing end-to-end support
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Site upkeep + analytics
                        </li>
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Ads & SEO strategy
                        </li>
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Multichannel support with reports
                        </li>
                        <li className="ct_fs_16 ct_text_op_8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_43087)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#023047"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_43087">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          SDR/sales rep support
                        </li>
                      </ul>
                    </div>
                    <div class="mt-auto">
                      <a class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48">
                        Choose Plan
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <section class=" ct_px_40 pt-0 ct_mt_100 ct_mb_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_about_cnt">
                <h2 class=" ct_fs_32  ct_mb_60">Frequently asked questions</h2>

                <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                  <div class="accordion" id="faq_accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faq_one">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_one"
                          aria-expanded="false"
                          aria-controls="collapsefaq_one"
                        >
                          How do I get started as a freelancer on NUVIO?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_one"
                        class="accordion-collapse collapse"
                        aria-labelledby="faq_one"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            Simply sign up for an account, create your profile
                            highlighting your skills and experience, and start
                            browsing or applying for projects that interest you.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqtwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Two"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          What types of projects can I find on NUVIO?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Two"
                        class="accordion-collapse collapse "
                        aria-labelledby="faqtwo"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            Simply sign up for an account, create your profile
                            highlighting your skills and experience, and start
                            browsing or applying for projects that interest you.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqthree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Three"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Three"
                        >
                          How does payment work?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Three"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqthree"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            Simply sign up for an account, create your profile
                            highlighting your skills and experience, and start
                            browsing or applying for projects that interest you.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Four"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Four"
                        >
                          What support does NUVIO provide to freelancers?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Four"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFour"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            Simply sign up for an account, create your profile
                            highlighting your skills and experience, and start
                            browsing or applying for projects that interest you.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_about_img">
                <img
                  src="../assets/img/faq_678890-4.png"
                  class="ct_img_h_617 ct_border_radius_20"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </MenuLayout>
  );
};

export default SalesServiceSubscription;
